/**
 * Toggle an element's class
 */
export function toggleClass(el, classname) {
	if (el.classList.contains(classname)) {
		el.classList.remove(classname);
	} else {
		el.classList.add(classname);
	}
}

/**
 * Toggle an attribute's aria label values
 */
export function toggleAttribute(el, attribute) {
	const currentAttribute = el.getAttribute(attribute);
	if (currentAttribute === 'false') {
		el.setAttribute(attribute, 'true');
	} else {
		el.setAttribute(attribute, 'false');
	}
}
